import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/EmailOutlined';

const Navbar = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 20,
        backgroundColor: { xs: '#5B2D8E', md: 'transparent' },
        borderRadius: 0,
        boxShadow: 'none',
        height: { xs: '80px', md: 'auto' },
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            py: { xs: 2, md: 2 },
          }}
        >

          {/* Logo & Tagline */}
          <Box sx={{ backgroundColor: { xs: '#fff', md: 'none' }, p: { xs: 1, md: 0 }, borderRadius: { xs: '10px', md: '0' } }}>
            <Box
              component="a"
              href="/"
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textDecoration: 'none',
                position: 'relative',
                height: { xs: 45, md: 60 },
                width: { xs: 120, md: 160 },
              }}
            >
              <Box
                component="img"
                src="/vihaan-tours-logo.png"
                alt="Vihaan Tours Logo"
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  mt: { xs: 0, md: 2 },
                  height: { xs: 100, md: 165 },
                  width: 'auto',
                  maxWidth: 'none',
                }}
              />
            </Box>
          </Box>

          {/* Contact Info */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: { xs: 'flex-end', md: 'center' },
              gap: { xs: 2, md: 2 },
            }}
          >
            <Box
              component="a"
              href="mailto:vihaantoursandtravels2025@gmail.com"
              sx={{
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
                gap: { xs: 0.5, md: 0.75 },
                backgroundColor: { xs: 'transparent', md: 'rgba(255,255,255,0.85)' },
                backdropFilter: { md: 'blur(4px)' },
                px: { xs: 0, md: 2 },
                py: { xs: 0, md: 0.8 },
                borderRadius: { md: '25px' },
                color: { xs: '#fff', md: '#333' },
                boxShadow: { xs: 'none', md: '0 4px 10px rgba(0,0,0,0.05)' },
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  color: { xs: '#FFC107', md: '#5B2D8E' }
                }
              }}
            >
              <EmailIcon sx={{ fontSize: { xs: '0.9rem', md: '1.2rem' }, color: { xs: '#FFC107', md: '#5B2D8E' } }} />
              <Typography sx={{ fontWeight: 600, fontSize: { xs: '0.65rem', sm: '0.8rem', md: '0.9rem' } }}>
                vihaantoursandtravels2025@gmail.com
              </Typography>
            </Box>

            <Box
              component="a"
              href="tel:+919964848414"
              sx={{
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
                gap: { xs: 0.5, md: 0.75 },
                backgroundColor: { xs: 'transparent', md: 'rgba(255,255,255,0.85)' },
                backdropFilter: { md: 'blur(4px)' },
                px: { xs: 0, md: 2 },
                py: { xs: 0, md: 0.8 },
                borderRadius: { md: '25px' },
                color: { xs: '#fff', md: '#333' },
                boxShadow: { xs: 'none', md: '0 4px 10px rgba(0,0,0,0.05)' },
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  color: { xs: '#FFC107', md: '#5B2D8E' }
                }
              }}
            >
              <PhoneIcon sx={{ fontSize: { xs: '0.9rem', md: '1.2rem' }, color: { xs: '#FFC107', md: '#5B2D8E' } }} />
              <Typography sx={{ fontWeight: 600, fontSize: { xs: '0.65rem', sm: '0.8rem', md: '0.9rem' }, letterSpacing: '0.5px' }}>
                +91 99648 48414
              </Typography>
            </Box>


          </Box>


        </Box>
      </Container>
    </Box>
  );
};

export default Navbar;
